import { phoneFormat } from '@utils/index';
import type { NotificationBody, NotificationContact } from '@/types';

/** Pure form model for notification contacts (shared by the form component and the unit tests). */
export interface NotificationFormValues {
  pvFullName: string;
  pvPhoneNumber: string;
  pvEmail: string;
  pvMethodOfContactText: boolean;
  pvMethodOfContactEmail: boolean;
  triggers: string[];
}

export const emptyNotification = (): NotificationFormValues => ({
  pvFullName: '',
  pvPhoneNumber: '',
  pvEmail: '',
  pvMethodOfContactText: false,
  pvMethodOfContactEmail: false,
  triggers: [],
});

export const toFormValues = (row: NotificationContact): NotificationFormValues => ({
  pvFullName: row.pvFullName || '',
  pvPhoneNumber: phoneFormat(row.pvPhoneNumber),
  pvEmail: row.pvEmail || '',
  pvMethodOfContactText: Number(row.pvMethodOfContactText) === 1,
  pvMethodOfContactEmail: Number(row.pvMethodOfContactEmail) === 1,
  triggers: [...(row.triggers || [])],
});

export const toBody = (values: NotificationFormValues): NotificationBody => ({
  pvFullName: values.pvFullName.trim(),
  pvPhoneNumber: values.pvPhoneNumber || null,
  pvEmail: values.pvEmail.trim() || null,
  pvMethodOfContactText: values.pvMethodOfContactText ? 1 : 0,
  pvMethodOfContactEmail: values.pvMethodOfContactEmail ? 1 : 0,
  triggers: values.triggers,
});

/**
 * Legacy rules: ALOC contacts (useNotificationForm.js) need a full name, a
 * method of contact and a trigger; equipment contacts only a full name
 * ("Please enter your full name").
 */
export const validateNotification = (
  values: NotificationFormValues,
  domain: 'lcert' | 'equipment' = 'lcert',
) => {
  const errors: Partial<Record<keyof NotificationFormValues, string>> = {};
  if (domain === 'equipment') {
    if (!values.pvFullName.trim()) errors.pvFullName = 'Please enter your full name';
    return errors;
  }
  if (!values.pvFullName.trim()) errors.pvFullName = 'Full Name is required';
  if (!values.pvMethodOfContactText && !values.pvMethodOfContactEmail)
    errors.pvMethodOfContactEmail = 'At least one method of contact is required';
  if (!values.triggers.length) errors.triggers = 'At least one trigger is required';
  return errors;
};
